import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { ComponentProps } from "react";
import { css, styled } from "~/application/theme";
import { contentStyle } from "./contentStyle";

export type DropdownMenuContentProps = ComponentProps<
  typeof DropdownMenuPrimitive.Content
>;

const contentClassName = css({
  ...contentStyle,
})();

export const DropdownMenuContent = ({
  children,
  ...props
}: DropdownMenuContentProps) => {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        sideOffset={8}
        {...props}
        className={`${contentClassName} ${props.className || ""}`}
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        {children}
      </DropdownMenuPrimitive.Content>
    </DropdownMenuPrimitive.Portal>
  );
};

DropdownMenuContent.displayName = "DropdownMenuContent";
